import { render, staticRenderFns } from "./AddLegDialog.vue?vue&type=template&id=a69cc2ae"
import script from "./AddLegDialog.vue?vue&type=script&lang=js"
export * from "./AddLegDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports